import { render, staticRenderFns } from "./GuestToolbar.vue?vue&type=template&id=0bac8b6d&scoped=true&"
import script from "./GuestToolbar.vue?vue&type=script&lang=ts&"
export * from "./GuestToolbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bac8b6d",
  null
  
)

export default component.exports